import { TFunction } from "i18next";
import { RequestDetailContent } from "@companion-core/shared/app/Components/Requests/RequestDetail/requestDetail.model";
import { APIProposalResponse, APIRecommendation } from "@companion-core/shared/app/Interfaces/API";

export const getProposalCardAriaLabel = (status: string, t: TFunction) => {
  switch (status) {
    case "recommended":
      return t("request.my-requests.detail.button.proposals.aria-label");
    case "proposal-rejected":
      return t("request.my-requests.detail.button.previous-proposals.aria-label");
    case "proposal-validated":
    case "booked":
      return t("request.my-requests.detail.button.selected-proposal.aria-label");
    default:
      return undefined;
  }
};

export const getProposalCardHref = (
  status: string,
  requestId: string | undefined,
  proposalsData: APIProposalResponse
) => {
  if (!requestId) {
    return undefined;
  }

  const listProposals = proposalsData?.data?.results?.filter((proposal) =>
    ["rejected", "validated"].includes(proposal.status)
  );
  const displayListRecommendations = listProposals?.length === 1 || status === "recommended";

  if (["recommended", "proposal-rejected"].includes(status)) {
    const content = displayListRecommendations
      ? RequestDetailContent.recommendations
      : RequestDetailContent.proposals;
    return `/my-requests/${requestId}/details/${content}`;
  }

  const validatedProposal = proposalsData?.data?.results?.find(
    (value) => value.status === "validated"
  );
  const recommendationValidated = validatedProposal?.recommendations?.find(
    (recommendation: APIRecommendation) => recommendation.status === "validated"
  );

  if (
    (status === "proposal-validated" || status === "booked") &&
    validatedProposal?.id &&
    recommendationValidated?.id
  ) {
    return `/my-requests/${requestId}/proposals/${validatedProposal.id}/recommendations/${recommendationValidated.id}`;
  }

  return undefined;
};
